import { Paper, WithStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';

import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Stepper from '@material-ui/core/Stepper';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { DropzoneArea } from 'material-ui-dropzone';
import * as React from 'react';
import { connect } from 'react-redux';
import { StaticContext } from 'react-router';
import { RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';
import {
	ISearchOrgUserItem,
	setSearchOrgUsersList,
} from 'src/actions/quickModeOrgUserRegisterIniUser';
import MessageDialog from 'src/components/MessageDialog';
import { IMessage } from '../actions/message';
import Progress from '../components/Progress';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import ScenarioFactory from '../scenario/QuickModeOrgUserRegisterUserListFactory';
import SiteConfig from '../site.config.json';
import QuickModeOrgUserRegisterTreeMain from './QuickModeOrgUserRegisterTreeMain';
const styles = (theme: Theme) =>
	createStyles({
		buttonContainer: {
			display: 'flex',
			flexDirection: 'column',
			marginLeft: '90px',
		},
		container: {
			'-webkit-align-items': 'center',
			display: 'flex',
			flexWrap: 'wrap',
			justifyContent: 'center',
		},
		dropzoneInput: {
			background: '#fff',
			borderColor: '#516ecb',
			borderRadius: '8px',
			margin: '20px',
			maxHeight: '105px',
			minHeight: '105px',
			width: '300px',
		},
		icon: {
			display: 'none',
		},
		image_downLoad: {
			cursor: 'pointer',
			margin: '20px 0px 20px 20px',
			width: '125px',
		},
		logButton: {
			float: 'right',
			height: '45px',
			marginRight: '70px',
			position: 'relative',
			width: '180px',
		},
		noticeText: {
			fontSize: '100%',
			margin: '20px',
			width: '235px',
			wordWrap: 'break-word',
		},
		paper: {
			height: 'auto',
			padding: '20px',
			width: '100%',
		},
		root: {
			flexGrow: 1,
			padding: 18,
			wordBreak: 'break-all',
		},
		signButton: {
			float: 'right',
			height: '45px',
			marginBottom: '8px',
			marginRight: '70px',
			position: 'relative',
			width: '180px',
		},
		stepLabel: {
			fontSize: '18px',
			textAlign: 'center',
		},
		stepper: {
			'@media (max-width: 600px)': {
				width: '100%',
			},
			width: '70%',
		},
		text: {
			margin: '0px',
		},
		textContainer: {
			display: 'table-cell',
			height: '100px',
			padding: '30px 10px',
			textAlign: 'center',
			verticalAlign: 'middle',
			width: '300px',
		},
		textStyle: {
			color: '#4472C4',
			fontSize: '25px',
			margin: '0px',
			whiteSpace: 'pre',
		},
		textStyle_fileName: {
			'-webkit-box-orient': 'vertical',
			'-webkit-line-clamp': '2',
			color: '#516ecb',
			display: '-webkit-box',
			fontSize: '15px',
			overflow: 'hidden',
			textAlign: 'center',
		},
	});

export interface IFileInfo {
	key: string;
	file: File;
	name: string;
	type: string;
	size: string;
}

interface IState {
	org_Id: string; // 前画面渡した組織ID
	messages: IMessage[];
	stepDatas: string[];
	fileName: string;
	Files: any;
	title: string;
	line: number;
	loading: boolean;
	openErrorMessageDialog: boolean;
	downloadImageSrc: string;
	vertical: boolean;
}
class QuickModeOrgUserRegister extends React.Component<IProps, IState> {
	// テンプレートをダウンロード用form
	protected templateDownloadForm: React.RefObject<HTMLFormElement>;
	protected logDownloadForm: React.RefObject<HTMLFormElement>;
	constructor(props: IProps) {
		super(props);
		this.state = {
			Files: null,
			downloadImageSrc: 'light',
			fileName: '',
			line: 0,
			loading: false,
			messages: [],
			openErrorMessageDialog: false,
			org_Id: this.props.location.state.org_Id,
			stepDatas: [
				i18n.t('QUICKMODE_ORGUSERREGISTER_STEP1TEXT'),
				i18n.t('QUICKMODE_ORGUSERREGISTER_STEP2TEXT'),
				i18n.t('QUICKMODE_ORGUSERREGISTER_STEP3TEXT'),
			],
			title: i18n.t('QUICKMODE_ORGUSERREGISTER_ERRORMESSAGE'),
			vertical: false,
		};
		this.logDownloadForm = React.createRef();
		this.templateDownloadForm = React.createRef();
		this.save = this.save.bind(this);
		this.errorMessageDialogClose = this.errorMessageDialogClose.bind(this);
		this.mouseOver = this.mouseOver.bind(this);
		this.mouseLeave = this.mouseLeave.bind(this);
		this.handleResize = this.handleResize.bind(this);
	}
	public dropRejected = (files: File[], event: any) => {
		if (files) {
			this.getFileAndValidate(files);
		}
	};
	public drop = (files: File[], event: any) => {
		if (files) {
			this.getFileAndValidate(files);
		}
	};
	public getFileAndValidate = async (files: File[]) => {
		let isDrop = true;
		const FileName: string = files[0].name;
		if (!FileName.endsWith('.xlsm')) {
			// ファイル type エラー
			isDrop = false;
			const messages: IMessage[] = [];
			const message: IMessage = {
				content: 'LMCM_E_16026',
			};
			messages.push(message);
			// メッセージを表示する。
			if (messages.length !== 0) {
				this.setState({
					messages,
					openErrorMessageDialog: true,
				});
			}
		}
		if (isDrop) {
			this.setState({
				Files: files[0],
				fileName: FileName,
			});
		}
	};

	public componentDidMount() {
		this.handleResize();
		window.addEventListener('resize', this.handleResize);
	}

	public handleResize() {
		const vertical = document.body.clientWidth < 600;
		this.setState({
			vertical,
		});
	}

	public componentWillUnmount() {
		window.removeEventListener('resize', this.handleResize);
	}
	public render() {
		const { classes } = this.props;
		const DropzoneAreaBaseClasses = {
			icon: classes.icon,
			text: classes.text,
			textContainer: classes.textContainer,
		};

		return (
			<div className={classes.root}>
				<Paper className={classes.paper}>
					<Progress open={this.state.loading} />
					<div className={classes.container}>
						<Stepper
							orientation={
								this.state.vertical ? 'vertical' : 'horizontal'
							}
							className={classes.stepper}
						>
							{this.state.stepDatas.map((step, i) => {
								return (
									<Step key={i} active={true}>
										<StepLabel>{step}</StepLabel>
									</Step>
								);
							})}
						</Stepper>
					</div>
					<div className={classes.container}>
						<img
							src={require('../images/download_' +
								this.state.downloadImageSrc +
								'.png')}
							className={classes.image_downLoad}
							onMouseOver={this.mouseOver}
							onMouseLeave={this.mouseLeave}
							onClick={this.handleDownloadTemplate}
						/>
						<form
							method="POST"
							action={
								SiteConfig.tsqPath +
								'/tsq/pkg/action/per/orgUserDownload.action'
							}
							ref={this.templateDownloadForm}
							target="_blank"
						>
							<input
								type="hidden"
								name="orgID"
								value={this.state.org_Id}
							/>
						</form>
						<p className={classes.noticeText}>
							{i18n.t('QUICKMODE_ORGUSERREGISTER_DOWNLOADTEXT')}
						</p>
						<DropzoneArea
							acceptedFiles={['.xlsm']}
							classes={DropzoneAreaBaseClasses}
							dropzoneText={
								this.state.fileName
									? this.state.fileName
									: i18n.t(
											'QUICKMODE_ORGUSERREGISTER_DROPHERE'
									  )
							}
							dropzoneClass={classes.dropzoneInput}
							dropzoneParagraphClass={
								this.state.fileName
									? classes.textStyle_fileName
									: classes.textStyle
							}
							filesLimit={1}
							showAlerts={false}
							showPreviews={false}
							showPreviewsInDropzone={false}
							showFileNamesInPreview={false}
							onDropRejected={this.dropRejected}
							onDrop={this.drop}
						/>
						<div className={classes.buttonContainer}>
							<Button
								variant="contained"
								color="primary"
								className={classes.signButton}
								onClick={this.save}
							>
								{i18n.t('QUICKMODE_ORGUSERREGISTER_SIGN')}
							</Button>
							<Button
								variant="contained"
								color="primary"
								className={classes.logButton}
								onClick={this.log}
							>
								{i18n.t('QUICKMODE_ORGUSERREGISTER_LOG')}
							</Button>
							<form
								method="POST"
								action={
									SiteConfig.tsqPath +
									'/tsq/pkg/action/per/logFileDownload.action'
								}
								ref={this.logDownloadForm}
								target="_blank"
							/>
						</div>
					</div>
				</Paper>
				{/* 組織ユーザツリー */}
				<QuickModeOrgUserRegisterTreeMain orgID={this.state.org_Id} />
				<MessageDialog
					open={this.state.openErrorMessageDialog}
					showCancelButton={false}
					title={this.state.title}
					contents={this.state.messages}
					onClose={this.errorMessageDialogClose}
					onClickOk={this.errorMessageDialogClose}
				/>
			</div>
		);
	}

	protected mouseOver() {
		this.setState({
			downloadImageSrc: 'deep',
		});
	}

	protected mouseLeave() {
		this.setState({
			downloadImageSrc: 'light',
		});
	}
	/**
	 * エラーメッセージクローズ
	 */
	protected errorMessageDialogClose() {
		this.setState({ openErrorMessageDialog: false, messages: [] });
	}
	/**
	 * テンプレートのダウンロード押下時ハンドラ
	 */
	protected handleDownloadTemplate = () => {
		if (this.templateDownloadForm.current) {
			this.templateDownloadForm.current.submit();
		}
	};
	/**
	 * ログ処理(read module)
	 * event: React.MouseEvent<HTMLElement>
	 */
	protected log = () => {
		// logButtonClick
		this.props.fetchLogDownload(this.props.token).then(() => {
			if (this.props.data) {
				if (this.props.data === '0') {
					const messages: IMessage[] = [];
					const message: IMessage = {
						content: 'CHK_E_0085',
					};
					messages.push(message);
					// メッセージを表示する。
					if (messages.length !== 0) {
						this.setState({
							messages,
							openErrorMessageDialog: true,
						});
					}
					return;
				} else if (this.props.data === '1') {
					// QuickModeOrgUserRegisterlogFileDownloadAction
					if (this.logDownloadForm.current) {
						this.logDownloadForm.current.submit();
					}
				}
			}
		});
	};
	/**
	 * 登録・更新ボタン
	 * event: React.MouseEvent<HTMLElement>
	 * @param event イベントオブジェクト
	 */
	protected save() {
		// drop hereの値に従ってボタン登録Buttonのスタイルを決定する
		if (!this.state.fileName) {
			const messages: IMessage[] = [];
			const message: IMessage = {
				content: 'CHK_E_0084',
			};
			messages.push(message);
			// メッセージを表示する。
			if (messages.length !== 0) {
				this.setState({
					messages,
					openErrorMessageDialog: true,
				});
			}
			return;
		}
		// ロードの設定
		this.setState({
			loading: true,
		});
		const form = new FormData();
		const modelData = {
			per_quickmode_QuickModeOrgUserListBlockModel: {},
		};
		form.append('file', this.state.Files);
		form.append('__modelData', JSON.stringify(modelData));
		const request = new XMLHttpRequest();
		request.open(
			'POST',
			SiteConfig.tsqPath + '/tsq/ui/common/resources/rest/file/upload',
			true
		);
		request.setRequestHeader('Accept', 'application/json');
		request.onreadystatechange = () => {
			if (request.readyState === 4 && request.status === 200) {
				this.setState({
					loading: false,
				});
				const response = JSON.parse(request.responseText);
				let result = 0;
				if (
					response.per_quickmode_QuickModeOrgUserListBlockModel !==
					(null && undefined && '')
				) {
					result =
						response.per_quickmode_QuickModeOrgUserListBlockModel;
				}
				if (result === 1) {
					const messages: IMessage[] = [];
					const message: IMessage = {
						// 登録処理が完了しました。
						content: 'CHK_I_0023',
					};
					messages.push(message);
					// メッセージを表示する。
					if (messages.length !== 0) {
						this.setState({
							messages,
							openErrorMessageDialog: true,
							title: i18n.t('QuickModeTextAndTestCreate_0005'),
						});
					}
				} else if (result === 0) {
					const messages: IMessage[] = [];
					const message: IMessage = {
						// 登録処理に失敗しました。
						content: 'CHK_E_0086',
					};
					messages.push(message);
					// メッセージを表示する。
					if (messages.length !== 0) {
						this.setState({
							messages,
							openErrorMessageDialog: true,
							title: i18n.t(
								'QUICKMODE_ORGUSERREGISTER_ERRORMESSAGE'
							),
						});
					}
				} else {
					const messages: IMessage[] = [];
					const message: IMessage = {
						content: response.tsqErrorMessage[0].message,
					};
					messages.push(message);
					if (messages.length !== 0) {
						this.setState({
							messages,
							openErrorMessageDialog: true,
						});
					}
				}
			}
			const orgID = this.state.org_Id;
			this.props.fetchQuickModeDataTree(orgID, this.props.token);
		};
		request.send(form);
	}
}
const mapStateToProps = (state: IRootState) => ({
	data: state.searchLogFileState.searchLogFile,
	searchOrgUserItemArry:
		state.quickModeOrgUserRegisterTreeObj.searchOrgUserItemArry,
	token: state.session.token,
});
const mapDispatchToProps = (dispatch: Dispatch) => ({
	fetchLogDownload: (token: string) => {
		const s = ScenarioFactory.createFetchLogDownload(dispatch, token);
		return s.run({});
	},
	fetchQuickModeDataTree: (orgID: string, token: string) => {
		const s = ScenarioFactory.createFetchQuickModeOrgUserList(
			dispatch,
			token
		);
		s.run(orgID);
	},
	setSearchOrgUsersList: (searchOrgUserItemArry: ISearchOrgUserItem[]) =>
		dispatch(setSearchOrgUsersList({ searchOrgUserItemArry })),
});

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

interface IRouteState {
	org_Id: string;
}

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> &
	RouteComponentProps<{}, StaticContext, IRouteState>;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(QuickModeOrgUserRegister);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/containers/QuickModeOrgUserRegister.tsx